import { render, staticRenderFns } from "./InsertMemoryDropdown.vue?vue&type=template&id=6e131ff4&scoped=true"
import script from "./InsertMemoryDropdown.vue?vue&type=script&lang=js"
export * from "./InsertMemoryDropdown.vue?vue&type=script&lang=js"
import style0 from "./InsertMemoryDropdown.vue?vue&type=style&index=0&id=6e131ff4&prod&lang=scss&scoped=true"
import style1 from "./InsertMemoryDropdown.vue?vue&type=style&index=1&id=6e131ff4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e131ff4",
  null
  
)

export default component.exports